import { render, staticRenderFns } from "./invitationDetail.vue?vue&type=template&id=287c4d84&scoped=true&"
import script from "./invitationDetail.vue?vue&type=script&lang=js&"
export * from "./invitationDetail.vue?vue&type=script&lang=js&"
import style0 from "./invitationDetail.vue?vue&type=style&index=0&id=287c4d84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287c4d84",
  null
  
)

export default component.exports